// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3Qarj","footer":"ModalFilter_footer__FTZuR"};